import React from "react";
import './studieLine.css'

const StudieLine = () => {
    return (
        <div className="studieLine flex">
            <span className="circle"></span>
            <span className="line"></span>
        </div>
    )
}

export default StudieLine